import LayoutActividad from "../../../components/LayoutActividad";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import { modulo14 } from "../../../routes/Module14";
import GuiaDocente from "../../../components/GuiaDocente";
import Sidebar from "../Sidebar";
import Tucan from "../../../images/modulo14/tucan.png";
import Chanikuy from "../../../images/modulo14/chanikuy.png";
import Mopaten from "../../../images/modulo14/mopaten.png";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo14/Unidad1Actividad5.mp3";

const Actividad8 = () => {
  const infoUnidad = modulo14.content[0];
  const infoAct = modulo14.content[0].activities[6];
  const crumbs = [
    {
      title: modulo14.title,
      url: "/" + modulo14.url,
    },
    {
      title: `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo14.content[0].name}: ${modulo14.content[0].activities[7].name}`,
    linkNext: `${modulo14.url}/${modulo14.content[0].path}/${modulo14.content[0].activities[7].path}`,
    titlePrev: `${modulo14.content[0].name}: ${modulo14.content[0].activities[5].name}`,
    linkPrev: `${modulo14.url}/${modulo14.content[0].path}/${modulo14.content[0].activities[5].path}`,
  };
  const metadata = {
    color: modulo14.color,
    title: `${modulo14.title} - ${infoAct.name}`,
    name: modulo14.title,
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo14.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />

      <div className="row">
        <div className="col-lg-10 col-12">
          <ul>
            <li>
              Hay palabras en algunas lenguas originarias del Perú que no tienen
              una traducción exacta en una palabra del castellano.
            </li>
            <li>
              Lee las siguientes palabras y sus definiciones y conversa con un
              compañero, compañera o familiar: ¿en qué ocasiones crees que sería
              útil usar estas palabras? Den ejemplos de su vida diaria.
            </li>
          </ul>
        </div>
      </div>
      <div className="row align-items-center my-5 px-4">
        <div className="col-lg-4 col-md-6 col-12">
          <div className="border-2 border rounded shadow-sm text-center p-4">
            <strong>
              NODO: <br /> Volar (un ave) desde el suelo hasta la copa de un
              árbol (lengua matsés o mayoruna - Loreto).
            </strong>
          </div>
        </div>
        <div className="col-lg-8 col-md-6 col-12">
          <img src={Tucan} className="bg-white img-fluid" alt="Multicolor" />
        </div>
      </div>
      <div className="row align-items-center my-5 px-4">
        <div className="col-lg-4 col-md-6 col-12">
          <div className="border-2 border rounded shadow-sm text-center p-4">
            <strong>
              MOPA`TEN:
              <br /> Negarse a compartir algo con alguien (lengua yanesha -
              Huánuco, Pasco, Junín).
            </strong>
          </div>
        </div>
        <div className="col-lg-8 col-md-6 col-12">
          <img src={Mopaten} className="bg-white img-fluid" alt="Multicolor" />
        </div>
      </div>
      <div className="row align-items-center my-5 px-4">
        <div className="col-lg-4 col-md-6 col-12">
          <div className="border-2 border rounded shadow-sm text-center p-4">
            <strong>
              CHANIKUY:
              <br /> Guardarse algo rico para poder compartirlo con sus seres
              queridos (lengua quechua chanka - Ayacucho y Apurímac).
            </strong>
          </div>
        </div>
        <div className="col-lg-8 col-md-6 col-12">
          <img src={Chanikuy} className="bg-white img-fluid" alt="Multicolor" />
        </div>
      </div>

      <small>
        (Tomado de: Ministerio de Cultura del Perú (s/f). 12 palabras de lenguas
        indígenas que abrirán tu mente. En:
        https://issuu.com/mincu/docs/12_palabras).
      </small>

      <GuiaDocente>
        <ul>
          <li>
            Explique que en las siguientes actividades dialogarán sobre algunos
            aspectos importantes de las lenguas originarias en el Perú. El
            objetivo es resaltar no solo el aspecto comunicativo que las lenguas
            originarias tienen para las comunidades que las usan, sino reconocer
            su importancia cultural.
          </li>
          <li>
            Lea en voz alta la afirmación presentada: Hay palabras en algunas
            lenguas originarias del Perú que no tienen una traducción exacta en
            una palabra del castellano. Pida que describan en voz alta las tres
            imágenes que aparecen. No deben leer de qué se trata, solo describir
            lo que observan en cada una de las ilustraciones. Por ejemplo:
            <ul>
              <li>
                <i>
                  “En la primera imagen aparece un ave (tucán) que está volando
                  hacia un árbol.
                </i>
              </li>
              <li>
                <i>
                  En la segunda imagen aparecen dos personas. Traen trajes
                  tradicionales. La mujer tiene un plátano verde en la mano y
                  parece que no lo quiere compartir.
                </i>
              </li>
              <li>
                <i>
                  En la tercera imagen, podría tratarse de una familia en la que
                  el papá llega con pan para compartir”.
                </i>
              </li>
            </ul>
          </li>

          <li>
            Lea la siguiente indicación: Lee las siguientes palabras y sus
            definiciones y conversa con un compañero o compañera: ¿en qué
            ocasiones crees que sería útil usar estas palabras? Den ejemplos de
            su vida diaria. Para llevar a cabo la actividad, pida que primero
            lean las palabras, su significado, el nombre de la lengua y en qué
            lugar o lugares se habla. Luego, deberán pensar entre ambos en qué
            momentos específicos podrían usar esas palabras.
          </li>
          <li>
            {" "}
            Pregunte por los ejemplos que han elaborado. Retome las palabras,
            sus significados, el nombre y lugares en que se hablan las lenguas.
            Por ejemplo:
            <ul>
              <li>
                <i>
                  “Tenemos la palabra “nodo”, ¿quién puede leer su significado?
                  (Respuesta: Volar (un ave) desde el suelo hasta la copa de un
                  árbol.)
                </i>
              </li>
              <li>
                <i>
                  ¿En qué lengua está la palabra? (Respuesta: En lengua matsés o
                  mayoruna.)
                </i>
              </li>
              <li>
                <i>¿Dónde se habla esa lengua? (Respuesta: En Loreto.)</i>
              </li>
              <li>
                <i>
                  Ahora, ¿qué ejemplos han elaborado?. Es decir, ¿cuándo
                  podríamos utilizar la palabra “nodo”? (Posible respuesta:
                  Estaba en el parque y asusté a la paloma. Entonces esta voló
                  hasta el árbol. Ahí se podría utilizar la palabra “nodo”).”
                </i>
              </li>
            </ul>
          </li>

          <li>
            Continúe de la misma manera con las siguientes palabras. Intente
            recoger varios de los ejemplos elaborados.
          </li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad8;
